export default [
  {
    path: '/vars',
    name: 'vars',
    component: () => import('@/views/Variables/List/VariableList'),
  }
]